import { axiosInstance } from "@/config/axiosInstance";

// Types
export interface CompanyHoliday {
  holidayName: string;
  date: Date | string;
  description: string;
  isHalfDay: boolean;
  minimumHours: number;
}

export interface CompanyHolidayList {
  _id: string;
  name: string;
  year: number;
  holidays: CompanyHoliday[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// GET ALL Company Holiday Lists (Admin)
export const getAllCompanyHolidayLists = (adminKey: string) =>
  axiosInstance
    .get<{
      success: boolean;
      foundLists: CompanyHolidayList[];
      error?: string;
    }>("/company-holiday/all", {
      headers: {
        authorization: `Bearer ${adminKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

// GET ONE Company Holiday List (Admin)
export const getOneCompanyHolidayList =
  (adminKey: string) => (id: string) =>
    axiosInstance
      .get<{
        success: boolean;
        foundList: CompanyHolidayList;
        error?: string;
      }>(`/company-holiday/one/${id}`, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

// GET ACTIVE Company Holiday List (Admin)
export const getActiveCompanyHolidayListAdmin =
  (adminKey: string) => (year?: number) =>
    axiosInstance
      .post<{
        success: boolean;
        foundList: CompanyHolidayList | null;
        error?: string;
      }>(
        "/company-holiday/active",
        { year },
        {
          headers: {
            authorization: `Bearer ${adminKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

// GET ACTIVE Company Holiday List (Employee)
export const getActiveCompanyHolidayListEmployee =
  (employeeKey: string) => (year?: number) =>
    axiosInstance
      .post<{
        success: boolean;
        foundList: CompanyHolidayList | null;
        error?: string;
      }>(
        "/company-holiday/employee/active",
        { year },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);
